"use client";
import DefaultContact from "@/templates/default/pages/Contact";
import { ContactPageProps } from "@/templates/types";
import { ContactPagesLoader } from "../page-template-loaders/contact-page-loader";

const ContactPage: React.FC<ContactPageProps> = (props) => {
  return (
    <ContactPagesLoader>
      <DefaultContact {...props} />
    </ContactPagesLoader>
  );
};

export default ContactPage;
